<template>
  <div id="login-page">
    <b-form id="login-form">
      <div id="moresimp"></div>
      <div id="passman_login_logo"></div>
      <b-form-row>
        <b-form-input type="text" class="input-field" id="username" name="username" :placeholder="$t('message.username')"
          autocomplete="new-username" autofocus v-model="username" @keyup.enter.native="login"/>
      </b-form-row>
      <b-form-row>
        <b-form-input type="password" class="input-field" id="password" name="password" :placeholder="$t('message.password')"
          autocomplete="new-password" v-model="password"@keyup.enter.native="login"
          :disabled="showForgotPassword"/>
      </b-form-row>
      <b-form-row v-if="multifactorRequired">
        <b-form-input type="text" class="input-field" id="time-based-secret" name="time-based-secret"
          :placeholder="$t('message.time_based_secret')" autocomplete="new-password" autofocus v-model="time_based_secret"
          @keyup.enter.native="login"/>
      </b-form-row>

      <div v-if="errorMessage" class="form-error">{{errorMessage}}</div>

      <b-button v-if="multifactorSharedSecret" id="show-multifactor-shared-secret"
        v-on:click="$refs['multifactor-shared-secret-modal'].show()" type="button" variant="primary"
        class="padmin-button">
        {{$t('message.button_show_multifactor_shared_secret_dialog').toUpperCase()}}
      </b-button>

      <b-button v-if="!showForgotPassword" id="login-submit" v-on:click="login" type="button" variant="primary"
        class="padmin-button submit-button">
        {{$t('message.button_login').toUpperCase()}}
      </b-button>
      <b-button v-if="showForgotPassword" id="reset-password-submit" v-on:click="resetPasswordEmail" type="button" variant="primary"
        class="padmin-button submit-button">
        {{$t("message.button_reset_password_email").toUpperCase()}}
      </b-button>
      <div>
        <b-link v-if="!showForgotPassword" href="#" @click="showForgotPassword=true">{{$t("message.forgot_password")}}</b-link>
      </div>
    </b-form>

    <b-modal ref="reset-password-email-modal" hide-footer>
      <div>
        {{$t('message.reset_password_email_info')}}:
      </div>
    </b-modal>

    <b-modal id="multifactor-shared-secret-modal" ref="multifactor-shared-secret-modal" hide-footer>
      <div id="multifactor-qr-code">
        <qrcode-vue :value="multifactorQrString" :size="200" level="H" />
      </div>
      <div id="multifactor-shared-secret">
        <span id="shared-secret-val">{{multifactorSharedSecret}}</span>
        <b-link href="#" @click="copyToClipboard" id="shared-secret-copy">
          {{$t('message.button_copy') | title}}
        </b-link>
      </div>
      <div id="multifactor-qr-text">
        {{$t('message.multifactor_qr_text')}}
      </div>
    </b-modal>
  </div>
</template>

<script>
import {generateRandomChars} from "../util"
import { post } from "../http";
import { EventBus } from "../event-bus.js";
import QrcodeVue from "qrcode.vue"
export default {
  name: "Login",

  components: {
    QrcodeVue
  },

  props: {
    reset_password_token: String
  },

  data() {
    return {
      username: '',
      password: '',
      errorMessage: null,
      showForgotPassword: false,
      reset_password_token: null,
      multifactorSharedSecret: null,
      multifactorRequired: null
    }
  },

  mounted() {
    EventBus.$emit('logged out')
  },

  methods: {
    login() {
      this.errorMessage = null
      let spqr = generateRandomChars(64)
      window.localStorage.removeItem('auth_token')
      window.localStorage.setItem('spqr', spqr)
      let data = { username: this.username, password: this.password, _id: spqr,
        time_based_secret: this.time_based_secret}
      post('/auth', data).then(
        resp => {
          if (resp) {
            if (resp.data.access_token) {
              window.localStorage.setItem('auth_token', resp.data.access_token)
              EventBus.$emit('logged in')
              this.$router.replace("/")
            }
            this.multifactorRequired = resp.data.multifactor_required
            this.multifactorSharedSecret = resp.data.multifactor_shared_secret
            this.multifactorQrString = resp.data.multifactor_qr_string
            if (this.multifactorSharedSecret) {
              this.$refs['multifactor-shared-secret-modal'].show()
            }
          } else {
            this.errorMessage = this.$t('message.error_auth_failed')
          }
        },
        error => {
          if (error.response.status == 503) {
            this.errorMessage = this.$t('message.error_too_many_login_attempts')
          } else if (error.response.status == 502) {
            this.errorMessage = this.$t('message.error_bad_gateway')
          } else if (error.response.status) {
            this.errorMessage = 'Status ' + error.response.status
          } else {
            this.errorMessage = error.response
          }
          this.username = ''
          this.password = ''
        })
    },

    resetPasswordEmail() {
      if (!this.username || this.username.length == 0) {
        this.errorMessage = this.$t('message.error_username_empty')
        return
      }
      this.errorMessage = null
      let data = { username: this.username }
      post('/reset_password_email', data).then(
        resp => {
          if (resp.data.error) {
            this.errorMessage = resp.data.error
          } else {
            this.$refs['reset-password-email-modal'].show()
          }
        },
        error => {
            this.errorMessage = error.response;
        })
      this.username = ''
      this.password = ''
    },

    copyToClipboard() {
      navigator.clipboard.writeText(document.getElementById('shared-secret-val').innerText)
    }
  }
}
</script>

<style scoped>
@import "./../styles/login.css";
</style>
